import * as React from 'react';
export const SVGComponent = (props) => (
  <svg
    height={16}
    viewBox='0 0 16.201 30.223'
    width={16}
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M68.09,19.994a3.423,3.423,0,1,1-3.408,2.243,2.771,2.771,0,0,1-.611-2.576c.737.838,2.822.271,4.019.34Zm3.874,28.371a1.521,1.521,0,0,1-3.043,0V42.728c0-.768.113-1.959-1.027-1.959s-1.02,1.191-1.02,1.959v5.638a1.521,1.521,0,0,1-3.043,0V33.084a.6.6,0,0,0-1.209,0v5.4a1.411,1.411,0,0,1-2.822,0V33.707c0-2.986,1.335-5.726,4.68-5.726h6.841c3.345,0,4.68,2.734,4.68,5.726v4.775a1.411,1.411,0,0,1-2.822,0v-5.4a.6.6,0,0,0-1.209-.013V48.365Z'
      data-name='Path 4378'
      fill='#007e75'
      id='Path_4378'
      transform='translate(-59.8 -19.66)'
    />
  </svg>
);
